export const fallbackNeutral = require('../assets/neutral.svg');
export const fallbackCompany = require('../assets/company.svg');
export const fallbackGroups = require('../assets/groups.svg');
export const fallbackTopic = require('../assets/topic.svg');
export const fallbackMale = require('../assets/male.svg');
export const fallbackFemale = require('../assets/female.svg');
//# sourceMappingURL=fallbacks.js.map